import { type as typeUtil } from '@mews/framework';

export function Member({ profileId = null, fullName = '', isEmployee = false } = {}) {
    return typeUtil.create(Member, {
        profileId,
        fullName,
        isEmployee,
    });
}
